import React from "react";
import { Icon, Tooltip } from "antd";
import { createUseStyles } from "react-jss";

import colors from "../../../../colors";

const useStyles = createUseStyles({
  customIcon: (props) => ({
    fontSize: props.size || 22,
    marginLeft: props.marginLeft || 0,
    marginRight: props.marginRight || 0,
    color: props.color || colors.DARK_GREY,
  }),
  customIconTitle: (props) => ({
    maxWidth: props.tooltipWidth,
  }),
});

const CustomIcon = ({
  type,
  size,
  color,
  title,
  onClick,
  placement,
  className,
  marginLeft,
  marginRight,
  tooltipWidth,
}) => {
  const classes = useStyles({
    size,
    color,
    marginLeft,
    marginRight,
    tooltipWidth,
  });
  return (
    <Tooltip
      title={title}
      placement={placement}
      overlayClassName={classes.customIconTitle}
    >
      <Icon
        type={type}
        onClick={onClick}
        className={`${className || ""} ${classes.customIcon}`}
      />
    </Tooltip>
  );
};

export default CustomIcon;
